<script lang="ts">
    import NauiButton from "../naui/atoms/NauiButton.svelte";

    export let links: Array<any> = [];
</script>
<div>
    <table class="naui-table" style="min-width: 300px">
        <thead>
        <tr>
            <th colspan="2">
                <div>
                    Plantillas
                </div>
            </th>
        </tr>
        </thead>
        <tbody>
        {#each links as link}
            <tr>
                <td>
                    <div>
                        {link.label}
                    </div>
                </td>
                <td>
                    <div class="text-c">
                        <NauiButton
                                download={true}
                                href={link.url}
                                icon="arrow-to-bottom"
                                color="accent"/>
                    </div>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
</div>